import { type ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  trailing?: ReactNode;
  className?: string;
}

export default function SectionHeader({
  title,
  trailing,
  className = '',
}: SectionHeaderProps) {
  return (
    <div className={`flex items-center justify-between mb-4 ${className}`}>
      <h3 className="text-heading2 text-label-normal">{title}</h3>
      {trailing && <div>{trailing}</div>}
    </div>
  );
}